export const INSIGHT_TYPE = {
    Displacement: "displacement",
    RankChange: "rank_change",
    VisibilityGap: "visibility_gap",
    Momentum: "momentum",
    Invisibility: "invisibility",
    Concentration: "concentration",
    RankPosition: "rank_position",
} as const;

export type InsightType = (typeof INSIGHT_TYPE)[keyof typeof INSIGHT_TYPE];

export interface IInsightTypeConfig {
    translationKey: string;
    badgeColor: string;
}

export interface ICompetitiveInsightsResponse {
    insights: Partial<Record<InsightType, string>>;
}

export interface IInsightEntry {
    type: InsightType;
    text: string;
}
